module.exports = __webpack_public_path__ + "img/11.1c87938b.png";